import * as Sentry from '@sentry/react';

const IS_DEV = import.meta.env.MODE === 'development';
const ENABLE_SENTRY = import.meta.env.VITE_ENABLE_SENTRY === 'true';

export const errorLogger = {
  error: (error, context = {}) => {
    if (IS_DEV || !ENABLE_SENTRY) {
      //eslint-disable-next-line no-console
      console.error(
        `%c [ERROR] ➡ `,
        'background: red; color: white; padding: 2px 6px; border-radius: 4px; font-weight: bold;',
        error,
        context,
      );
    }

    if (ENABLE_SENTRY) {
      Sentry.captureException(error, { extra: context });
    }
  },
};
